module.exports = __webpack_public_path__ + "img/multidevice.5eea4e63.png";